import { Container } from "@mantine/core"
import { Loader, Select } from "@tfg/ui"
import { useEffect, useState } from "react"

type Props = {
  data: { label: string; value: string }[] | string[]
  initialValue: string
  onChange: (value: string | undefined) => void
  isCreating: boolean
}

export function SelectCell({
  data,
  initialValue,
  onChange,
  isCreating,
}: Props) {
  const [values, setValues] = useState<string | undefined>(initialValue)

  useEffect(() => setValues(initialValue), [initialValue])
  return (
    <Container miw={300}>
      {!isCreating ? (
        <Select
          data={data}
          value={values}
          searchable
          onChange={(value) => {
            setValues(value ? value : undefined)
            onChange(value ? value : undefined)
          }}
        />
      ) : (
        <Loader type="dots" />
      )}
    </Container>
  )
}
